import React from 'react';
import './About.css';
import DirectorImage from '../assets/images/h.jpg';



const values = [
  { icon: 'fas fa-shield-alt', title: 'Integrity', desc: 'Every transaction is transparent, honest, and legally verified from start to finish.' },
  { icon: 'fas fa-award', title: 'Excellence', desc: 'We never compromise on quality — every plot and property meets our premium standard.' },
  { icon: 'fas fa-heart', title: 'Client First', desc: 'Your goals drive everything we do. We listen, advise, and deliver with care.' },
  { icon: 'fas fa-handshake', title: 'Commitment', desc: 'From first enquiry to registration, we stay with you as your trusted partner.' },
];

const About = () => {
  return (
    <div className="about-page page-container">

      {/* ── Hero Banner ── */}
      <section className="about-hero">
        <div className="about-hero-content">
          <span className="section-eyebrow">Our Story</span>
          <h1 className="about-hero-title">
            Building Dreams Along <span className="amber-text">ECR &amp; OMR</span>
          </h1>
          <p className="about-hero-sub" style={{ marginBottom: '1rem' }}>
            Vetri Realtors Pvt Ltd — a company born from a passion for premium real estate
            and a commitment to making property ownership accessible, legal, and joyful.
          </p>
        </div>
      </section>

      {/* ── Mission + Director ── */}
      <section className="about-core">
        <div className="about-mission">
          <span className="section-eyebrow">Our Mission</span>
          <h2 className="section-heading">Transparency. Trust. Excellence.</h2>
          <p className="about-description">
            Vetri Realtors specializes in premium real estate services with a focus on farm lands,
            residential plots, and properties in prime locations along ECR and OMR. With an
            unwavering commitment to integrity, we deliver unparalleled service to clients in
            Chennai's most sought-after coastal corridors.
          </p>
          <ul className="services-list">
            {['Buying & Selling Farm Lands','Residential Plot Transactions','Legal Opinions & Documentation','Property Registration Process','ECR & OMR Property Specialists','Investment Advisory'].map(s => (
              <li key={s}>
                <i className="fas fa-check-circle gold-icon" />
                {s}
              </li>
            ))}
          </ul>
        </div>

        <div className="leadership">
          <div className="director-card">
            <div className="director-image">
              <img src={DirectorImage} alt="Udhaya Vendan R - Managing Director" />
              <div className="gold-frame" />
            </div>
            <h3>Udhaya Vendan R</h3>
            <p>Managing Director</p>
            <p className="director-bio">
              A visionary leader with deep roots in ECR &amp; OMR real estate, committed to making premium property accessible for all.
            </p>
            <div className="director-contact">
              <a href="mailto:vetrirealtorspvtltd@gmail.com" className="contact-link">
                <i className="fas fa-envelope" /> Email
              </a>
              <a href="tel:+918438623133" className="contact-link">
                <i className="fas fa-phone-alt" /> Call
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ── Core Values ── */}
      <section className="values-section">
        <div className="section-header-left">
          <span className="section-eyebrow">What Drives Us</span>
          <h2 className="section-heading">Our Core Values</h2>
        </div>
        <div className="values-grid">
          {values.map(({ icon, title, desc }) => (
            <div key={title} className="value-card card-hover">
              <div className="value-icon-wrap">
                <i className={`${icon} value-icon`} />
              </div>
              <h3>{title}</h3>
              <p>{desc}</p>
            </div>
          ))}
        </div>
      </section>


      {/* ── Legal Info ── */}
      <section className="legal-section">
        <div className="legal-details">
          <div className="section-header-left">
            <span className="section-eyebrow">Registered Entity</span>
            <h2 className="section-heading">Company Information</h2>
          </div>
          <div className="legal-grid">
            {[
              { label: 'CIN', value: 'U68200TN2025TC18545' },
              { label: 'TAN', value: 'CHEV26094F' },
              { label: 'PAN', value: 'AALCV261IC' },
              { label: 'Address', value: 'No.2. Thirum, East Coast Road, Kovalam, Chengalpattu District, PIN-603112', full: true },
            ].map(({ label, value, full }) => (
              <div key={label} className={`legal-item ${full ? 'full-width' : ''}`}>
                <span className="legal-label">{label}</span>
                <span className="legal-value">{value}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
};

export default About;